import script from "./dict-type.vue?vue&type=script&setup=true&lang=js"
export * from "./dict-type.vue?vue&type=script&setup=true&lang=js"

import "./dict-type.vue?vue&type=style&index=0&id=1529483e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1529483e"]])

export default __exports__